import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const HeaderImage = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1l5bjh90"
} : {
  target: "e1l5bjh90",
  label: "HeaderImage"
})(process.env.NODE_ENV === "production" ? {
  name: "ppumqv",
  styles: "overflow:hidden;width:100%;margin:auto"
} : {
  name: "ppumqv",
  styles: "overflow:hidden;width:100%;margin:auto/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvbWVkaWEvSGVhZGVySW1hZ2UvSGVhZGVySW1hZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRThCIiwiZmlsZSI6Ii9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvbWVkaWEvSGVhZGVySW1hZ2UvSGVhZGVySW1hZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IEhlYWRlckltYWdlID0gc3R5bGVkLmRpdmBcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgd2lkdGg6IDEwMCU7XG4gIG1hcmdpbjogYXV0bztcbmA7XG5cbmV4cG9ydCBkZWZhdWx0IEhlYWRlckltYWdlO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export default HeaderImage;